module.exports = __webpack_public_path__ + "static/media/IMG_1281.7b3a0e66.jpg";